
import React from 'react';
import { motion } from 'framer-motion';

const LightningStrike: React.FC<{ color: string; delay: number }> = ({ color, delay }) => {
  return (
    <motion.svg
      className="absolute inset-0 w-full h-full pointer-events-none z-[5] overflow-visible"
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 1, 0, 1, 0] }}
      transition={{ 
        duration: 0.15, 
        repeat: Infinity, 
        repeatDelay: delay + Math.random() * 10,
        times: [0, 0.2, 0.4, 0.6, 1]
      }}
    >
      <motion.path
        d={`M ${Math.random() * 100}% 0 L ${Math.random() * 100}% 20% L ${Math.random() * 100}% 40% L ${Math.random() * 100}% 100%`}
        stroke={color}
        strokeWidth="6"
        strokeOpacity="0.4"
        fill="none"
      />
      <motion.path
        d={`M ${Math.random() * 100}% 0 L ${Math.random() * 100}% 20% L ${Math.random() * 100}% 40% L ${Math.random() * 100}% 100%`}
        stroke="white"
        strokeWidth="1"
        fill="none"
      />
    </motion.svg>
  );
};

export const NeonLightning: React.FC = () => {
  return (
    <>
      <LightningStrike color="#00f3ff" delay={3} />
      <LightningStrike color="#ffffff" delay={5} />
      <div className="fixed inset-0 pointer-events-none z-[1] bg-[radial-gradient(circle_at_50%_50%,transparent_0%,rgba(0,0,0,0.4)_100%)]"></div>
    </>
  );
};
